<template>
    <v-container fluid fill-height class="text-center d-flex align-center justify-center"
        style="max-width: 300px; min-width: 300px">

        <div class="Absolute-Center">

        </div>

    </v-container>
</template>

<script>

import router from ".././router";
import apiholidaypermits from "../utils/holidaypermits/apiholidaypermits";


export default {

    mounted: async function () {

        var anno = window.$cookies.get("sel_anno_ver_ts");
        var mese = window.$cookies.get("sel_mese_ver_ts");

        window.$cookies.set("yearStartPeriodTsCalendar", parseInt(anno), "9y");
        window.$cookies.set("monthStartPeriodTsCalendar", parseInt(mese) - 1, "9y");
        window.$cookies.set("dayStartPeriodTsCalendar", 1, "9y");


        var last_day = new Date(anno, mese, 0).getDate();

        console.log("LAST_DAY: ", last_day);
        
        window.$cookies.set("yearEndPeriodTsCalendar", parseInt(anno), "9y");
        window.$cookies.set("monthEndPeriodTsCalendar", parseInt(mese) - 1, "9y");
        window.$cookies.set("dayEndPeriodTsCalendar", last_day, "9y");

        setTimeout(() => {

            router.push({
                path: "/editVerificaTimesheetCalendar/"
            });

        }, 500);



    },

    data: () => ({
        showPicker: false,

    }),

    methods: {


        getPeriodDisease: async function (v_id) {

            var that = this;


            var response = await apiholidaypermits.getPeriodDisease(
                v_id
            ).then((res) => {

                console.log("res from getPeriodDisease", res);

                var elements = res.data.periodo_dal.split("-");

                console.log(elements);

                var v_anno = parseInt(elements[0]);
                var v_mese = parseInt(elements[1]) - 1;
                var v_giorno = parseInt(elements[2]);

                window.$cookies.set("yearStartPeriodDisease", v_anno, "9y");
                window.$cookies.set("monthStartPeriodDisease", v_mese, "9y");
                window.$cookies.set("dayStartPeriodDisease", v_giorno, "9y");



                var elements2 = res.data.periodo_al.split("-");

                console.log(elements2);

                var v_anno2 = parseInt(elements2[0]);
                var v_mese2 = parseInt(elements2[1]) - 1;
                var v_giorno2 = parseInt(elements2[2]);

                window.$cookies.set("yearEndPeriodDisease", v_anno2, "9y");
                window.$cookies.set("monthEndPeriodDisease", v_mese2, "9y");
                window.$cookies.set("dayEndPeriodDisease", v_giorno2, "9y");



                setTimeout(() => {

                    router.push({
                        path: "/editDiseaseNew/" + that.$route.params.id
                    });

                }, 500);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile eliminare questa richiesta");
                console.log("response", response);

            }

            );



        }


    },
};
</script>
